import * as Sentry from '@sentry/react'

export function isSentryLoggingEnabled() {
  const hsGlobal = window.hsGlobal || {}
  const { features } = hsGlobal

  return features?.isSentryClientSideLoggingEnabled
}

export function initSentry(
  { app, additionalConfig = {} } = { additionalConfig: {} }
) {
  const hsGlobal = window.hsGlobal || {}
  const { memberId, companyId } = hsGlobal
  const dsn =
    'https://c73f511340d68e3ddff062fb2b456508@o27212.ingest.sentry.io/4506232391335936'
  const environment = process.env.NODE_ENV
  const release = process.env.RELEASE_ID

  if (!isSentryLoggingEnabled()) {
    return
  }

  Sentry.init({
    dsn,
    environment,
    release,
    ...additionalConfig,
  })

  // Custom `user` properties are not search indexed in sentry
  // so we also need to set a tag for companyId
  Sentry.setTag('hs.companyId', companyId)

  Sentry.setUser({
    id: memberId,
    companyId: companyId, // Not indexed, but available on the detail view in sentry
  })

  if (app) {
    Sentry.setTag('hs.application', app)
  }
}
